
import { OPERATOR_PAGE_API } from '../config/apiPoints';
import { fetchHelper } from '../../utils/fetchHelper';
import getDateObj from './../Common/utils/GetDateObj';

export const prepareOperatorPageRequest = (params) => {
  return `${__ENV_CONFIG__.__PAGEROVER__}${OPERATOR_PAGE_API}?slug=${params.operatorName}-bus-booking${params.operatorId ? params.operatorId : ''}`
}

export async function getOperatorPageData(params) {
  const url = prepareOperatorPageRequest(params);
  let data = {}
  try {
    data = await fetchHelper({
      name: 'route page',
      type: 'GET',
      url: url,
    });
  } catch (err) {
    data = {
      status: false,
      error: true
    }
  }
  return data;

}
export const getOperatorKey = (operator="", operator_id="", bus_type="", mstr="") => {
  const d = getDateObj();
  const year = d.getFullYear();
  const month = d.getMonth();
  const day = d.getDate();
  return `bus_mweb_operator${operator ? `_${operator}` : ''}${operator_id ? `_${operator_id}` : ''}${bus_type ? `_${bus_type}` : ''}_${year}-${+month + 1}-${day}${mstr ? `_${mstr}` : ''}`
}
